import React from "react";
import Head from "next/head";
import {phpContent} from "../../../../utils/php-utils/php-content";
import {bool, oneOfType, string, object} from "prop-types";
import {resolveShareImage} from "../../../../constants/seo";

function getContent(isPHP, content, selector, attr) {
  return isPHP ? phpContent(selector, attr)(content) : content;
}

export default function CustomOG({
  title,
  description,
  isPHP,
  image = "",
  url = "",
  type = "website",
  site_name = "Медиа Столото"
}) {
  const ogImage = isPHP
    ? (image?.default || image)
    : resolveShareImage(image);
  const twImage = isPHP
    ? (image?.tw || image)
    : ((typeof image === "object" && image?.tw) || resolveShareImage(image));
  const vkImage = isPHP
    ? (image?.vk || image)
    : ((typeof image === "object" && image?.vk) || resolveShareImage(image));

  return (
    <Head>
      <meta property="og:title" content={
        getContent(isPHP, title, 'meta[property="og:title"]', "content")
      }/>
      <meta name="description" content={
        getContent(isPHP, description, 'meta[name="description"]', "content")
      }/>
      <meta property="og:description"
            content={
              getContent(isPHP, description, 'meta[property="og:description"]', "content")
            }/>
      <meta property="og:url" content={
        getContent(isPHP, url, 'meta[property="og:url"]', "content")
      }/>
      <meta name="og:url" content={
        getContent(isPHP, url, 'meta[name="og:url"]', "content")
      }/>
      <meta property="og:site_name" content={
        getContent(isPHP, site_name, 'meta[property="og:site_name"]', "content")
      }/>
      <meta property="og:type" content={
        getContent(isPHP, type, 'meta[property="og:type"]', "content")
      }/>
      <meta content="1200" property="og:image:width"/>
      <meta content="675" property="og:image:height"/>
      <meta content="summary_large_image" name="twitter:card"/>
      <meta content={
        getContent(isPHP, ogImage, 'meta[property="og:image"]', "content")
      } property="og:image"/>
      <meta content={
        getContent(isPHP, twImage, 'meta[name="twitter:image"]', "content")
      } name="twitter:image"/>
      <meta content={
        getContent(isPHP, vkImage, 'meta[name="vk:image"]', "content")
      } name="vk:image"/>
      <meta content={
        getContent(isPHP, vkImage, 'meta[property="vk:image"]', "content")
      } property="vk:image"/>
    </Head>
  );
}

CustomOG.propTypes = {
  title: string,
  description: string,
  isPHP: bool,
  image: oneOfType([string, object]),
  url: string,
};
